export const SEMVER_REGEX =
  /^(\d+)\.(\d+)\.(\d+)(?:-([\w\d-.]+))?(?:\+([\w\d-.]+))?$/;
